<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,785.5c-1.86,0-3.74,0.84-4.95,2.05c-1.21,1.21-2.05,3.09-2.05,4.95s0.84,3.74,2.05,4.95c1.21,1.21,3.09,2.05,4.95,2.05
	s3.74-0.84,4.95-2.05c1.21-1.21,2.05-3.09,2.05-4.95s-0.84-3.74-2.05-4.95C4.24,786.34,2.36,785.5,0.5,785.5z M4.03,788.97
	c0.96,0.96,1.46,2.08,1.46,3.53s-0.5,2.57-1.46,3.53c-0.96,0.96-2.08,1.46-3.53,1.46s-2.57-0.5-3.53-1.46s-1.46-2.08-1.46-3.53
	s0.5-2.57,1.46-3.53s2.08-1.46,3.53-1.46S3.07,788.01,4.03,788.97z M-9.5,802.5c5-8,12-15,20-20C5.5,790.5-1.5,797.5-9.5,802.5
	L-9.5,802.5z"/>
</svg>

</template>